import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./Mgrdetail.css";

export default function ApramattDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Apramatt
        </h1>

        <p className="project-description">
          We partnered with Apramatt to design a comprehensive brand identity and digital presence, delivering premium product packaging, corporate catalog designs, and a modern, responsive website. Our creative approach focused on capturing Apramatt's expertise in photography and videography gear, presenting their professional equipment through structured, visually-rich layouts that engage both retail customers and distributors.
        </p>

        <div className="project-tags">
          <span className="info-tag">Brand Identity</span>
          <span className="info-tag">Website Design</span>
          <span className="info-tag">Packaging Design</span>
          <span className="info-tag">Brochure Design</span>
        </div>
      </section>

      {/* Full landscape image */}
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Apramatt/Full3.webp" alt="Apramatt Branding Showcase" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We built a responsive, modern website for Apramatt, focusing on clean user experiences, seamless navigation, and high-quality product photography to showcase their range of camera accessories."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Apramatt/Full1.webp" alt="Apramatt Branding Showcase" />
      </div>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Apramatt/Full4.webp" alt="Apramatt Branding Showcase" />
      </div>
      {/* Quote text below the images */}
      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed high-impact packaging systems for Apramatt's products, engineered to stand out on retail shelves and online marketplaces with premium typography and clean branding."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Apramatt/Full2.webp" alt="Apramatt Branding Showcase" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Our team crafted a premium corporate catalog for Apramatt, translating their extensive product lines of tripods, lights, and batteries into a beautifully structured, tactile print layout."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Apramatt/Full5.webp" alt="Apramatt Branding Showcase" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Every packaging and visual identity detail has been created to assure quality, matching the high standards expected by photography and videography professionals."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Apramatt/Full6.webp" alt="Apramatt Branding Showcase" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "From logo conception to final catalog execution, the new identity highlights Apramatt's position as a premier brand for content creators and photography enthusiasts in India."
        </div>
      </section>

      <RelatedWorks excludePath="/works/apramatt" />
      <Footer />
    </div>
  );
}
